import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'capitalSpace',
    standalone: false
})
export class CapitalSpacePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return value;

    // Use regex to add a space before each capital letter
    //return value.replace(/([A-Z])/g, ' $1');
    const cValue = value.replaceAll(/([A-Z])/g, ' $1');
    return cValue.replaceAll('To', 'to').replaceAll('From', 'from');
  }

}
